function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#202124",
  fillRule: "nonzero",
  stroke: "#202124"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M.33 9.817c.014-.015.03-.03.047-.045l6.906-5.526c.244-.193.52-.273.826-.238.307.035.558.174.751.418.195.243.276.518.242.826-.036.308-.175.56-.418.754l-4.35 3.48h12.004c2.427.001 4.498.859 6.213 2.574 1.715 1.72 2.573 3.793 2.573 6.22 0 2.427-.858 4.498-2.573 6.213-1.715 1.715-3.786 2.572-6.213 2.573H5.931c-.311 0-.576-.11-.796-.33-.22-.22-.33-.485-.33-.795 0-.31.11-.576.33-.796.22-.22.485-.33.796-.33h10.407c1.806.001 3.346-.637 4.622-1.913 1.276-1.276 1.914-2.816 1.914-4.622s-.638-3.35-1.914-4.63c-1.276-1.276-2.816-1.913-4.622-1.913H4.313l4.609 3.722c.24.197.378.449.411.758.033.306-.049.58-.245.822-.195.243-.446.38-.754.415-.308.033-.583-.047-.826-.242L.418 11.49c-.064-.052-.12-.107-.167-.167-.073-.088-.13-.183-.17-.285-.005-.012-.01-.023-.013-.034l-.007-.017c-.007-.019-.013-.037-.017-.055-.031-.101-.046-.206-.044-.316l.003-.095.004-.034.034-.176c.012-.05.03-.099.051-.146.008-.02.017-.039.027-.058l.061-.109c.042-.064.092-.124.15-.18z",
  transform: "translate(-409 -430) translate(385 414) translate(24 16)"
})))));

var SvgIconReturn = function SvgIconReturn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconReturn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-return.1b10a503.svg";
export { ForwardRef as ReactComponent };